import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        totalUser : {},
        districts : {},
        provinces : {}
    },
    getters: {
        getTotalUser: state => state.totalUser,
        getDistricts: state => state.districts,
        getProvinces: state => state.provinces,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setTotalUser(state, { resp }){
            if (resp) {
                state.totalUser = resp.data.data
            }
        },
        setDistricts(state, { resp }){
            if (resp) {
                state.districts = resp.data.data
            }
        },
        setProvinces(state, { resp }){
            if (resp) {
                state.provinces = resp.data.data
            }
        }
    },
    actions: {
        getTotalUser({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/landing-page/get-total-user',
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setTotalUser', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getDistricts({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/home/get-district/'+form.code+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setDistricts', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getProvinces({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/home/get-province?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setProvinces', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    },
}
